import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HelpNavigationService {

  constructor() { }
  selectedSection =
    new BehaviorSubject<string>('introduction');
}
